import React from "react";
import { observer } from "mobx-react-lite";
import ReactWordcloud from "react-wordcloud";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";

const WORD_CLOUD_OPTIONS = {
    rotations: 1,
    rotationAngles: [0, 90],
    enableTooltip: true,
    deterministic: false,
    fontFamily: "impact",
    fontSizes: [5, 60] as [number, number],
    fontStyle: "normal",
    fontWeight: "normal",
    padding: 1,
    scale: "sqrt" as const,
    spiral: "archimedean" as const,
};

const wordCloudCallbacks = {
    getWordColor: (word: { sentiment?: string }) => {
        switch (word.sentiment) {
            case "positive":
                return "#1E8449";
            case "negative":
                return "#B03A2E";
            case "neutral":
                return "#717D7E";
            default:
                return "#212F3C";
        }
    },
    getWordTooltip: (word: { text: string; value: number }) => `${word.text} (${word.value})`,
};

export const WordCloud = observer(({ words = [] }: { words?: Array<{ text: string; value: number; sentiment?: string }> }) => (
    <div className="h-auto w-full">
        <ReactWordcloud callbacks={wordCloudCallbacks as any} options={WORD_CLOUD_OPTIONS as any} words={words} />
    </div>
));
